var GMap, GMapDesktop2016V2Markers, GMapModalView, InlineMap, Rolodex,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GMap = window.GMap != null ? window.GMap : window.GMap = {};

if (GMap.vent == null) {
  GMap.vent = require('../../../frontend/helpers/events');
}

InlineMap = require('./g_map');

GMapDesktop2016V2Markers = require('../markers');

Rolodex = require('../rolodex');

module.exports = GMapModalView = (function(superClass) {
  extend(GMapModalView, superClass);

  function GMapModalView() {
    return GMapModalView.__super__.constructor.apply(this, arguments);
  }

  GMapModalView.prototype.events = {
    'click .location-modal-head': function(event) {
      return this.toggleRolodex(event);
    },
    'click .merchant-location-card': function(event) {
      var card, cards;
      card = $(event.currentTarget);
      cards = this.$el.find('.merchant-location-card');
      return this.highlightSelectedMerchant({
        index: cards.index(card)
      });
    }
  };

  GMapModalView.prototype._handleMarkerClick = function(index) {
    index = Math.floor(index / 2);
    this.reCenterMap(index);
    if (this.openCard !== index) {
      this.$el.find('.merchant-location-card').eq(index).click();
    }
    return this.openCard = index;
  };

  GMapModalView.prototype._handleStreetViewOpen = function() {
    var overlayItems, streetViewObject;
    streetViewObject = this.activeMap.getStreetView();
    overlayItems = this.$el.find('.merchant-location-cards, .location-modal-head');
    return this.googleMaps.event.addListener(streetViewObject, 'visible_changed', function() {
      if (streetViewObject.getVisible()) {
        return overlayItems.hide();
      } else {
        return overlayItems.show();
      }
    });
  };

  GMapModalView.prototype.initialize = function() {
    GMapModalView.__super__.initialize.apply(this, arguments);
    this.getLocationModalHead();
    return $('body').on("modal-open:locations", (function(_this) {
      return function() {
        return _this.rolodex = new Rolodex({
          $el: _this.$el.find('.merchant-cards-container'),
          minLength: 3,
          header: {
            offsetTop: _this.locationModalHead.offset().top,
            height: _this.locationModalHead.height()
          }
        });
      };
    })(this));
  };

  GMapModalView.prototype.start = function() {
    GMapModalView.__super__.start.apply(this, arguments);
    return this._handleStreetViewOpen();
  };

  GMapModalView.prototype.getLocationModalHead = function() {
    return this.locationModalHead = this.$el.find('.location-modal-head');
  };

  GMapModalView.prototype.toggleRolodex = function(event) {
    var arrow;
    event.preventDefault();
    arrow = $(event.currentTarget).find('a');
    if (arrow.hasClass('arrow-down')) {
      arrow.removeClass('arrow-down icon-arrow-down-large').addClass('arrow-up icon-arrow-up-large');
    } else {
      arrow.removeClass('arrow-up icon-arrow-up-large').addClass('arrow-down icon-arrow-down-large');
    }
    if (this.rolodex != null) {
      return this.rolodex.toggleVisibility(event);
    }
  };

  return GMapModalView;

})(InlineMap);

//# sourceMappingURL=data:application/json;base64,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
